import { Maybe, SafetyDataSheet, Specification } from '@/eshop/gql/graphql'
import {
    languageCodeToLanguageName,
    languageIdToLanguageCode,
} from '@/eshop/constants'
import clsx from 'clsx'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'

export type DataItem =
    | Maybe<Specification & { translateKey?: string }>
    | Maybe<SafetyDataSheet & { translateKey?: string }>
interface LanguageDropdownProps {
    data: DataItem[]
    tabIndex: number
}

const domainReg = /^(?:https?:\/\/)?(?:[^@\n]+@)?([^:\/\n?]+)/i

export const LanguageDropdown = ({ data, tabIndex }: LanguageDropdownProps) => {
    const { t } = useTranslation()

    return (
        <ul
            tabIndex={tabIndex}
            className="dropdown-content z-[1] menu p-2 m-4 shadow bg-base-100 rounded-box w-52 absolute top-2.5 right-0.5"
        >
            {data.map((item) => {
                const languageCode =
                    languageIdToLanguageCode[item?.languageId ?? 1]
                if (!languageCode) {
                    return null
                }

                const isExternalLink = item?.url?.startsWith('http')

                const label = isExternalLink
                    ? item?.url?.match(domainReg)?.[1]
                    : item?.translateKey
                    ? t(item?.translateKey)
                    : t(languageCodeToLanguageName[languageCode])

                return (
                    <li key={item?.id + item?.url}>
                        <div
                            onClick={() =>
                                window.open(
                                    isExternalLink
                                        ? item?.url
                                        : `${process.env.NEXT_PUBLIC_ESHOP_S3}${item?.url}`,
                                    '_blank'
                                )
                            }
                            className={clsx(
                                'text-black',
                                isExternalLink &&
                                    'text-blue-400 underline text-sm'
                            )}
                        >
                            <>
                                {!item?.translateKey && (
                                    <Image
                                        src={`https://flagcdn.com/${languageCode}.svg`}
                                        alt={t(
                                            item?.translateKey
                                                ? item?.translateKey
                                                : languageCodeToLanguageName[
                                                      languageCode
                                                  ]
                                        )}
                                        width={20}
                                        height={20}
                                    />
                                )}
                                {label}
                            </>
                        </div>
                    </li>
                )
            })}
        </ul>
    )
}
